import { render, staticRenderFns } from "./ShortlistListIcon.vue?vue&type=template&id=3eb6136c"
import script from "./ShortlistListIcon.vue?vue&type=script&lang=js"
export * from "./ShortlistListIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports